/**
 * The trip to Google's consent page, the same from every screen that offers it: `authorize-url`
 * mints the address and a `state`, the state is stashed for `/konto/google`, and the page is replaced.
 */

import { getMeCalendarConnectionsGoogleAuthorizeUrl } from '~/shared/api/generated/endpoints/my-google-calendar-connection/my-google-calendar-connection';

import { leaveDocument } from '~/shared/lib/documentExit';

import { isGoogleConsentUrl } from '../model/googleConsentUrl';
import { googleReturnPage, stashGoogleState } from './googleConnectStash';

/**
 * @param stillWanted asked once the answer lands: a screen that unmounted or let go of the press keeps the page.
 * @returns whether the page is leaving; rejects when the answer cannot start a trip (or the read failed).
 */
export async function goToGoogleConsent(
  signal: AbortSignal,
  stillWanted: () => boolean = () => true,
): Promise<boolean> {
  const { url, state } = await getMeCalendarConnectionsGoogleAuthorizeUrl(
    { redirectUri: googleReturnPage() },
    undefined,
    signal,
  );
  if (signal.aborted || !stillWanted()) return false;
  if (!isGoogleConsentUrl(url) || state === null || state === '' || !stashGoogleState(state)) {
    throw new Error('The authorize answer cannot start a trip to Google.');
  }
  leaveDocument(url);
  return true;
}
